<template>
  <div class="contentArea">
    <base-dialog :show="successModal" small>
      <div class="success my-10">
        <img src="../assets/success.svg" alt="" />
        <h2 class="mt-10 text-white">{{ successText }}</h2>
      </div>
    </base-dialog>
    <form @submit.prevent="submitForm">
      <h2 class="mb-5">ข้อมูลผู้รับเงิน</h2>
      <div class="card">
        <div class="grid grid-cols-12 gap-x-5 gap-y-3">
          <p class="col-span-2">โลโก้ :</p>
          <div class="col-span-10">
            <div class="logo-container" @click="$refs.fileInput.click()">
              <img class="logo-img" v-if="logoLink" :src="logoLink" alt="" />
              <div v-else class="flex justify-center items-center h-full">
                <font-awesome-icon
                  icon="plus"
                  class="mr-1"
                  :style="{ color: '#767a82' }"
                  size="2x"
                />
              </div>
            </div>
          </div>
          <input
            type="file"
            accept="image/*"
            id="file"
            style="display: none"
            ref="fileInput"
            @change="onSelectFile($event)"
          />
          <p class="col-span-2">ชื่อบริษัท (ไทย) :</p>
          <input
            class="col-span-4 w-10/12"
            type="text"
            tabindex="1"
            v-model="nameTh"
            required
          />
          <p class="col-span-2 row-span-2">ที่อยู่:</p>
          <textarea
            rows="3"
            class="col-span-4 row-span-2"
            v-model="address"
            placeholder="ที่อยู่"
            required
          />
          <p class="col-span-2">ชื่อบริษัท (Eng) :</p>
          <input
            class="col-span-4 w-10/12"
            type="text"
            tabindex="2"
            v-model="nameEng"
            required
          />
          <p class="col-span-2">รหัสผู้รับเงิน :</p>
          <input
            class="col-span-4 w-10/12"
            type="text"
            tabindex="3"
            placeholder="4 หลัก"
            v-model="accCode"
            minlength="4"
            maxlength="4"
            required
          />
          <p class="col-span-2 col-start-7">ตำบล/แขวง :</p>
          <input
            class="col-span-4"
            type="text"
            v-model="subDistrict"
            required
          />
          <p class="col-span-2 col-start-1 row-start-5">
            เลขประจำตัวผู้เสียภาษี :
          </p>
          <input
            class="col-span-4 row-start-5 w-10/12"
            type="text"
            tabindex="4"
            v-model="taxId"
            required
          />
          <p class="col-span-2">อำเภอ/เขต :</p>
          <input class="col-span-4" type="text" v-model="district" required />
          <p class="col-span-2 col-start-7">จังหวัด :</p>
          <select tabindex="-1" class="col-span-4" v-model="province">
            <option
              v-for="province in thaiProvince"
              :key="province"
              :value="province"
              >{{ province }}</option
            >
          </select>
          <p class="col-span-2 col-start-7">รหัสไปรษณีย์ :</p>
          <input class="col-span-4" type="number" v-model="postcode" required />
          <p class="col-span-2">เบอร์โทรศัพท์ :</p>
          <input
            class="col-span-4 w-10/12"
            type="text"
            tabindex="5"
            v-model="phone"
            required
          />
          <p class="col-span-2 col-start-1">อีเมล :</p>
          <input
            class="col-span-4 w-10/12"
            type="email"
            tabindex="6"
            v-model="email"
            required
          />
          <p class="col-span-2 col-start-7">ผู้อนุมัติ :</p>
          <input
            class="col-start-9 col-span-4"
            type="text"
            v-model="authorize"
          />
        </div>
      </div>
      <div class="grid grid-cols-10 gap-4 mt-5">
        <vs-button
          class="col-end-10"
          color="#ffffff"
          text-color="#8d9498"
          @click="goBackPage"
        >
          ยกเลิก
        </vs-button>
        <vs-button class="col-end-11" button="submit" color="#15c1c3">
          บันทึก
        </vs-button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "../util/backend.js";
import fileUrl from "../util/backendfile.js";
import Compressor from "compressorjs";
export default {
  data() {
    return {
      successModal: false,
      successText: "",
      thaiProvince: [
        "กรุงเทพมหานคร",
        "สมุทรปราการ",
        "นนทบุรี",
        "ปทุมธานี",
        "พระนครศรีอยุธยา",
        "อ่างทอง",
        "ลพบุรี",
        "สิงห์บุรี",
        "ชัยนาท",
        "สระบุรี",
        "ชลบุรี",
        "ระยอง",
        "จันทบุรี",
        "ตราด",
        "ฉะเชิงเทรา",
        "ปราจีนบุรี",
        "นครนายก",
        "สระแก้ว",
        "นครราชสีมา",
        "บุรีรัมย์",
        "สุรินทร์",
        "ศรีสะเกษ",
        "อุบลราชธานี",
        "ยโสธร",
        "ชัยภูมิ",
        "อำนาจเจริญ",
        "หนองบัวลำภู",
        "ขอนแก่น",
        "อุดรธานี",
        "เลย",
        "หนองคาย",
        "มหาสารคาม",
        "ร้อยเอ็ด",
        "กาฬสินธุ์",
        "สกลนคร",
        "นครพนม",
        "มุกดาหาร",
        "เชียงใหม่",
        "ลำพูน",
        "ลำปาง",
        "อุตรดิตถ์",
        "แพร่",
        "น่าน",
        "พะเยา",
        "เชียงราย",
        "แม่ฮ่องสอน",
        "นครสวรรค์",
        "อุทัยธานี",
        "กำแพงเพชร",
        "ตาก",
        "สุโขทัย",
        "พิษณุโลก",
        "พิจิตร",
        "เพชรบูรณ์",
        "ราชบุรี",
        "กาญจนบุรี",
        "สุพรรณบุรี",
        "นครปฐม",
        "สมุทรสาคร",
        "สมุทรสงคราม",
        "เพชรบุรี",
        "ประจวบคีรีขันธ์",
        "นครศรีธรรมราช",
        "กระบี่",
        "พังงา",
        "ภูเก็ต",
        "สุราษฎร์ธานี",
        "ระนอง",
        "ชุมพร",
        "สงขลา",
        "สตูล",
        "ตรัง",
        "พัทลุง",
        "ปัตตานี",
        "ยะลา",
        "นราธิวาส",
        "บึงกาฬ",
      ],
      logoLink: null,
      nameTh: "",
      nameEng: "",
      accCode: "",
      taxId: "",
      address: "",
      district: "",
      subDistrict: "",
      province: "กรุงเทพมหานคร",
      postcode: null,
      phone: "",
      email: "",
      authorize: "",
    };
  },
  watch: {
    accCode() {
      this.accCode = this.accCode.toUpperCase();
    },
  },
  methods: {
    async submitForm() {
      if (!this.$route.params.id) {
        try {
          const res = await axios.post(
            `${baseUrl}/accounting/create`,
            {
              logo: this.logoLink || null,
              name_th: this.nameTh,
              name_en: this.nameEng,
              acc_code: this.accCode,
              tax_id: this.taxId,
              address: this.address,
              district: this.district,
              subdistrict: this.subDistrict,
              province: this.province,
              postcode: this.postcode,
              phone: this.phone,
              email: this.email,
              authorize: this.authorize,
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
          if (res.data.status === "success") {
            this.successText = "เพิ่มสำเร็จ";
            this.successModal = true;
            setTimeout(() => {
              this.successModal = false;
              this.$router.replace("/accounting");
            }, 1000);
          } else {
            const error = new Error("เพิ่มผู้รับเงินไม่สำเร็จ");
            throw error;
          }
        } catch (err) {
          alert(err);
        }
      } else {
        try {
          const res = await axios.post(
            `${baseUrl}/accounting/edit?accounting_id=${this.$route.params.id}`,
            {
              logo: this.logoLink || null,
              name_th: this.nameTh,
              name_en: this.nameEng,
              acc_code: this.accCode,
              tax_id: this.taxId,
              address: this.address,
              district: this.district,
              subdistrict: this.subDistrict,
              province: this.province,
              postcode: this.postcode,
              phone: this.phone,
              email: this.email,
              authorize: this.authorize,
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
          if (res.data.status === "success") {
            this.successText = "แก้ไขสำเร็จ";
            this.successModal = true;
            setTimeout(() => {
              this.successModal = false;
              this.$router.replace("/accounting");
            }, 1000);
          } else {
            const error = new Error("แก้ไขผู้รับเงินไม่สำเร็จ");
            throw error;
          }
        } catch (err) {
          alert(err);
        }
      }
    },
    async onSelectFile(e) {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        let fileforupload = await this.compressImage(file);
        var fileupload = new File([fileforupload], file.name, {
          type: "image/jpeg",
        });
        let formData = new FormData();
        formData.append("file", fileupload);
        formData.append("folder_id", 1);
        await axios.post(`${fileUrl}/file/create`, formData).then((res) => {
          console.log("res", res);
          this.logoLink = res.data.data.uploadFileAtLevel.url;
        });
      }
    },
    compressImage(file) {
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: 0.6,
          success(result) {
            resolve(result);
          },
          error(e) {
            reject(e);
          },
        });
      });
    },
    goBackPage() {
      this.$router.go(-1);
    },
    async loadData() {
      if (this.$route.params.id) {
        const res = await axios.get(
          `${baseUrl}/accounting/get?accounting_id=${this.$route.params.id}`,
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
        console.log(res.data.data);
        const accountData = res.data.data;
        this.logoLink = accountData.logo;
        this.nameTh = accountData.name_th;
        this.nameEng = accountData.name_en;
        this.accCode = accountData.acc_code;
        this.taxId = accountData.tax_id;
        this.address = accountData.address;
        this.district = accountData.district;
        this.subDistrict = accountData.subdistrict;
        this.province = accountData.province;
        this.postcode = accountData.postcode;
        this.phone = accountData.phone;
        this.email = accountData.email;
        this.authorize = accountData.authorize;
      }
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped>
h2 {
  color: #ffffff;
}

p {
  color: #ffffff;
}

.card {
  background-color: #4e5363;
  border-radius: 5px;
  padding: 35px;
}

input[type="number"],
input[type="text"],
input[type="email"],
select,
textarea {
  border-radius: 2px;
  background: #3a3f51;
  border: none;
  color: #ffffff;
  font-size: 17px;
  padding-left: 10px;
}

textarea {
  padding-top: 5px;
}

select,
input[type="number"],
input[type="text"] {
  height: 34px;
  min-width: 0;
}

.success {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-container {
  display: block;
  border: 2px solid #767a82;
  box-sizing: border-box;
  border-radius: 5px;
  width: 100px;
  height: 100px;
  cursor: pointer;
}

.logo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
